<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'BANCOERROR.LBL_BANCOERRORES' | translate}}">
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fControles" name="fControles">
          <div class="grid form-group">
            <div class="col-12 md:col-4 lg:col-4">
              <div class="div-form">
                <label>* {{ 'BANCOERROR.LBL_CODIGO' | translate }}</label>
                <div *ngIf="!(bancoError && bancoError.idDescripcionErrorIntegracion)">
                  <input type="text" pInputText id="codigo"
                         name="nomCodigo"
                         autocomplete="off"
                         formControlName="codigo"
                         [maxlength]="10"
                         codigos-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                    {{ 'BANCOERROR.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
                <div *ngIf="bancoError && bancoError.idDescripcionErrorIntegracion">
                  <label class="falso-combo-texto">{{bancoError.codigo}}</label>
                </div>
              </div>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <div class="div-form">
                <label>* {{ 'BANCOERROR.LBL_INTEGRACION' | translate }}</label>
                <div *ngIf="!(bancoError && bancoError.idDescripcionErrorIntegracion)">
                  <p-dropdown disableTab  id="idIntegracion" name="nomIdIntegracion" [options]="lisIntegraciones"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                               formControlName="idIntegracion"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idIntegracion.invalid">
                    {{ 'BANCOERROR.LBL_INTEGRACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
                <div *ngIf="bancoError && bancoError.idDescripcionErrorIntegracion">
                  <label class="falso-combo-texto">{{bancoError.integracion}}</label>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                            id="indicadorHabilitado"
                            name="nomIndicador"
                            formControlName="indicadorHabilitado"></p-checkbox>
              </div>
            </div>
          </div>

          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'BANCOERROR.LBL_DESUSUARIO' | translate }}</label>
                <textarea id="descripcionUsuario" name="nomDescripcionUsuario" pInputTextarea rows="2"
                          capitalize-reactive [maxlength]="500"
                          formControlName="descripcionUsuario"></textarea>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descripcionUsuario.invalid">
                  {{ 'BANCOERROR.LBL_DESUSUARIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'BANCOERROR.LBL_DESTECNICA' | translate }}</label>
                <textarea id="descripcionTecnica" name="nomDescripcionTecnica" pInputTextarea rows="2"
                          capitalize-reactive [maxlength]="500"
                          formControlName="descripcionTecnica"></textarea>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descripcionTecnica.invalid">
                  {{ 'BANCOERROR.LBL_DESTECNICA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>

          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!guardando">
                <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                        type="submit"
                        pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>
        </form>
      </p-panel>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
